import { api } from './api';
import type {
  CreateTaskRequest,
  CreateTaskResponse,
  RetryResponse,
  TaskStatusResponse
} from '../types';

export const evaluationService = {
  create(input: Omit<CreateTaskRequest, 'idempotency_key'>, signal?: AbortSignal) {
    return api.post<CreateTaskResponse>(
      '/tasks',
      { ...input, idempotency_key: crypto.randomUUID() },
      signal
    );
  },
  status(taskId: string, signal?: AbortSignal) {
    return api.get<TaskStatusResponse>(`/tasks/${encodeURIComponent(taskId)}`, signal);
  },
  retry(taskId: string, articleId: string, signal?: AbortSignal) {
    return api.post<RetryResponse>(
      `/tasks/${encodeURIComponent(taskId)}/articles/${encodeURIComponent(articleId)}/retry`,
      undefined,
      signal
    );
  }
};
